export default "__VITE_PUBLIC_ASSET__8ceadc56__"